import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { SecureLinkType } from '@/types/myVaultTypes';

export const getSecureLinksApi = (params?: ApiParams): Promise<ApiResponseType<ListResponseType<SecureLinkType>>> => {
  return authApiService.GET('/my-vault/links/', params);
};
